import React, { useState } from "react"

import { Divider } from "antd"
import useOnclickOutside from "react-cool-onclickoutside"
import { FaCodeBranch } from "react-icons/fa"

import { CoverageHistoryMode } from "@common-shared/config/coverageHistory.config"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"
import { SelectElement } from "@front-shared/elements/select.element"
import { BrowserStorageHelper } from "@front-shared/helpers/browserStorage.helper"

import { GENERAL_CONFIG } from "../../config/general.config"

import closeIcon from "@front-shared/assets/images/icons/close-dark.svg"

export const ApiVersioningComponent: React.FunctionComponent<
    IApiVersioningComponentProps
> = props => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false)

    const toggle = (value?: boolean) => {
        setIsExpanded(current => {
            return typeof value === "undefined" ? !current : value
        })
    }

    const containerRef = useOnclickOutside(() => {
        toggle(false)
    })

    return (
        <div
            ref={containerRef}
            className={`
                relative
                ${props.className}
            `}
        >
            <FaCodeBranch
                size={32}
                color={NIRVANA_COLORS.brand.grey7}
                className="cursor-pointer"
                onClick={() => {
                    toggle()
                }}
            />

            {isExpanded && (
                <div
                    className="
                        absolute z-100 top-[44px] right-[16px] shadow-3
                        rounded-[6px] w-[400px] p-[24px] bg-brand-white
                    "
                >
                    <PrimaryText typography="h4Medium">
                        API Versioning
                    </PrimaryText>

                    <div
                        className="absolute right-[30px] top-[30px] cursor-pointer"
                        onClick={() => {
                            toggle(false)
                        }}
                    >
                        <img src={closeIcon} alt="Close" title="Close" />
                    </div>

                    <div className="mt-[40px]">
                        <div className="flex items-center gap-[16px]">
                            <SelectElement
                                className="flex-1"
                                name="coverageHistoryMode"
                                label="Coverage History Mode"
                                defaultValue={BrowserStorageHelper.get(
                                    GENERAL_CONFIG.browserStorageKeys
                                        .coverageHistoryMode,
                                )}
                                options={Object.values(CoverageHistoryMode).map(
                                    value => {
                                        return {
                                            value,
                                            label: value,
                                        }
                                    },
                                )}
                                onSelected={value => {
                                    if (
                                        BrowserStorageHelper.get(
                                            GENERAL_CONFIG.browserStorageKeys
                                                .coverageHistoryMode,
                                        ) === value
                                    ) {
                                        return
                                    }

                                    BrowserStorageHelper.set(
                                        GENERAL_CONFIG.browserStorageKeys
                                            .coverageHistoryMode,
                                        value,
                                    )

                                    window.location.reload()
                                }}
                            />

                            <ButtonElement
                                size="middle"
                                label="Reset"
                                htmlType="button"
                                type="primary"
                                onClick={() => {
                                    BrowserStorageHelper.remove(
                                        GENERAL_CONFIG.browserStorageKeys
                                            .coverageHistoryMode,
                                    )

                                    window.location.reload()
                                }}
                            />
                        </div>

                        <PrimaryText typography="caption" className="mt-[24px]">
                            <span className="text-semibold">
                                Default behavior
                            </span>
                            : <br />
                            <br />-{" "}
                            <span className="text-semibold">
                                Single Policy View:
                            </span>{" "}
                            HISTORICAL_COVERAGE <br />-{" "}
                            <span className="text-semibold">
                                Search List View:
                            </span>{" "}
                            HISTORICAL_COVERAGE <br />-{" "}
                            <span className="text-semibold">
                                All other List Views & Visualizations:
                            </span>{" "}
                            LATEST_COVERAGE <br />
                            <br />
                            <span className="text-semibold">
                                Coverage History Mode override applied to ALL
                                List Views & Visualizations
                            </span>
                        </PrimaryText>

                        <Divider />
                    </div>
                </div>
            )}
        </div>
    )
}

interface IApiVersioningComponentProps {
    className?: string
}
